var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoIcon = function SvgInfoIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.805,
    cy: 7.811,
    r: 7,
    stroke: "#4E7B57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E7B57",
    d: "M8.068 4.15c.693 0 1.25.19 1.67.57.426.374.64.89.64 1.55 0 .654-.21 1.154-.63 1.5-.42.34-.977.51-1.67.51l-.04.77h-1.23l-.05-1.7h.45c.58 0 1.026-.076 1.34-.23.313-.153.47-.433.47-.84 0-.293-.087-.526-.26-.7-.167-.173-.397-.26-.69-.26-.307 0-.547.084-.72.25-.167.167-.25.397-.25.69h-1.32c-.007-.406.08-.77.26-1.09.18-.32.443-.57.79-.75.353-.18.766-.27 1.24-.27Zm-.65 7.29a.894.894 0 0 1-.63-.23.802.802 0 0 1-.24-.59.77.77 0 0 1 .24-.58.873.873 0 0 1 .63-.24c.246 0 .45.08.61.24a.77.77 0 0 1 .24.58c0 .234-.08.43-.24.59a.846.846 0 0 1-.61.23Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info-icon.080c18d6850c6f18386357a612cad10c.svg";